import Box from "@mui/material/Box";
import { GridOverlay } from "@mui/x-data-grid-pro";

//#region Interfaces ... 
interface INoRowsOverlayProps {
    text?: string;
}
//#endregion


const GridNoRowsOverlay = (props: INoRowsOverlayProps) => {
    const text = props.text || "No data to display";

    return (
        <GridOverlay>
            <Box>{text}</Box>
        </GridOverlay>
        );
}

export default GridNoRowsOverlay;